import { ReactNode } from 'react';
import { mrhTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mrhTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
